import { render } from "./ShirtBlock.vue?vue&type=template&id=7d8ca26c"
import script from "./ShirtBlock.vue?vue&type=script&lang=js"
export * from "./ShirtBlock.vue?vue&type=script&lang=js"

import "./ShirtBlock.vue?vue&type=style&index=0&id=7d8ca26c&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__